import axios from 'axios'
import { DateTime } from 'luxon'
import React, { useEffect, useMemo, useState } from 'react'
import { useForm } from 'react-hook-form'
import { GrCircleInformation } from 'react-icons/gr'
import { Components } from 'safe'
import Tooltip from '../../components/Display/Tooltip'
import Form from '../../components/Form'
import FormItem from '../../components/Form/FormItem'
import Button from '../../components/General/Button'
import CurrencyInput from '../../components/Inputs/CurrencyInput'
import Datepicker from '../../components/Inputs/Datepicker'
import InputNumber from '../../components/Inputs/InputNumber'
import InputText from '../../components/Inputs/InputText'
import RawAutoComplete from '../../components/Inputs/RawAutoComplete'
import Select from '../../components/Inputs/Select'
import Switch from '../../components/Inputs/Switch'
import useSnackBars from '../../hooks/SnackbarConsumerHook'
import { dateToDB, formatPipe, getDenomination } from '../../utils/utils'

const server = process.env.REACT_APP_SERVER_URL

const IncomeForm: React.FC<IInvoiceForm> = ({
  onClose,
  onSubmit,
  type,
  bankOptions = [],
  idCurrency = null,
}) => {
  const form = useForm({
    defaultValues: {
      amount: 0,
      movementType: 'income',
    },
  })

  const today = DateTime.local().setLocale('es')


  const { addAlert } = useSnackBars()

  const incomeOption = [
    { text: 'Reintegro', value: 'REPAY' },
    { text: 'Crédito Bancario', value: 'BANK_LOAN' },
    { text: 'Préstamo', value: 'LOAN' },
    { text: 'Capital contribuido por accionistas', value: 'INVESTMENT' },
    { text: 'Intereses', value: 'INTEREST' },
    // { text: 'Pago de cuota', value: 'INSTALLMENT' },
    { text: 'Otro', value: 'OTHER' },
    { text: 'Avanzado', value: 'CUSTOM' },
    { text: 'Venta de inmueble', value: 'PROPERTY_SALE' },
  ]

  const outFlowOption = [
    { text: 'Pago de dividendos', value: 'DIVIDEND_PAYMENT' },
    { text: 'Nómina', value: 'PAYROLL' },
    // { text: 'Pago de cuota crédito comercial', value: 'INSTALLMENT' },
    { text: 'Otro', value: 'OTHER' },
    {
      text: 'Pago cuota crédito bancario',
      value: 'BANK_LOAN_INSTALLMENT',
    },
    {
      text: 'Pago interes crédito bancario',
      value: 'BANK_LOAN_INTEREST',
    },
    { text: 'Préstamo comercial', value: 'LOAN' },
    { text: 'Alquiler', value: 'RENT' },
    { text: 'Publicidad', value: 'MARKETING' },
    { text: 'Gastos de oficina', value: 'OFFICE_EXPENSES' },
    { text: 'Servicios', value: 'SERVICES' },
    { text: 'Pago igtf', value: 'IGTF_PAYMENT' },
    { text: 'Pago de islr', value: 'ISLR_PAYMENT' },
    {
      text: 'Pago de impuestos municipales',
      value: 'CITY_TAXES_PAYMENT',
    },
    { text: 'Pago de otros impuestos', value: 'OTHER_TAXES_PAYMENT' },
    { text: 'Comisión bancaria', value: 'BANK_COMMISSION' },
    { text: 'Avanzado', value: 'CUSTOM' },
    { text: 'Compra de inmueble', value: 'PROPERTY_INVESTMENT' },
  ]

  const [selectedType, setSelectedType] = useState<any>((type === 'INCOME' || type === 'BANK') ? incomeOption[0].value : outFlowOption[0].value)


  const typeOptions: Components.SelectOption[] =
    type === 'INCOME' ? incomeOption : outFlowOption

  const movementTypeOption = [
    { text: 'Entrada', value: 'income' },
    { text: 'Salida', value: 'outflow' },
  ]

  const searchOptions: Components.SelectOption[] = [
    { text: 'Cliente', value: 'client' },
    { text: 'Proveedor', value: 'provider' },
    { text: 'Otro', value: 'other' },
  ]

  const [accounts, setAccounts] = useState<any[]>([])

  const [selectedSearch, setSelectedSearch] = useState<string>(
    type === 'OUTFLOW' ? 'provider' : 'client'
  )

  const [selectedMovementType, setSelectedMovementType] = useState<string>(
    'income'
  )

  const [selectedAccount, setSelectedAccount] = useState<any | null>(null)

  const [selectedName, setselectedName] = useState<any | null>(null)

  const [selectedCustom, setSelectedCustom] = useState<string | null>(null)

  const [creditForm, setCreditForm] = useState<any | null>({
    currency: { id: '2' },
  })

  const [typeCopy, setTypeCopy] = useState('INCOME')

  const [selectedBank, setSelectedBank] = useState<string | null>('')

  const getAccounts = async (): Promise<void> => {
    // console.log("bank options", bankOptions)
    if (bankOptions.length > 0) {
      console.log('llega...', bankOptions)
      setAccounts(
        bankOptions.map((v) => ({ text: v?.description, value: v?.id }))
      )
      setSelectedAccount({
        text: bankOptions[0]?.description,
        value: bankOptions[0]?.id,
      })
      return
    }
    let response = await axios.get(`${server}/finances/account`)
    console.log('llegandoo...')
    setAccounts(response.data.accounts)
    let { accounts } = response.data
    setSelectedAccount({
      text: accounts[0]?.description,
      value: accounts[0]?.id,
    })
  }

  useEffect(() => {
    setTypeCopy(type)
  }, [type])

  useEffect(() => {
    console.log("Type", type)
    console.log("TYPE", type === 'INCOME')
  }, [selectedMovementType])

  useEffect(() => {
    getAccounts()
  }, [])

  const submitValues = (values) => {
    if (!selectedName && !values?.name) {
      addAlert({
        message: 'Es necesario el emisor',
        status: 'error',
      })
    } else {
      values.date = dateToDB(values?.date)
      let id = accounts?.find((v) => v?.id === values?.account?.id)?.idCurrency
      let objBody = {
        ...values,
        amount: values?.amount?.includes('-')
          ? formatPipe(values.amount, true) * -1
          : formatPipe(values.amount, true),
        account: { ...values.account, currency: { id } },
      }

      if (selectedSearch === 'client') {
        objBody = {
          [type === 'INCOME' ? 'payer' : 'beneficiary']: {
            client: {
              id: selectedName.id,
            },
          },
          ...objBody,
        }
        // objBody.payer.client.id = selectedName.id
      } else if (selectedSearch === 'provider') {
        objBody = {
          [type === 'INCOME' ? 'payer' : 'beneficiary']: {
            provider: {
              id: selectedName.id,
            },
          },
          ...objBody,
        }
      } else {
        objBody = {
          [type === 'INCOME' ? 'payer' : 'beneficiary']: {
            other: values.name,
          },
          ...objBody,
        }
      }

      if (selectedType === 'CUSTOM') {
        objBody = {
          ...objBody,
          custom: selectedCustom,
        }
        // console.log("llega..", objBody)
        // console.log("llega...", selectedCustom)
      }

      if (selectedType === 'LOAN' || selectedType === 'BANK_LOAN') {
        if (type === 'OUTFLOW' || selectedMovementType === 'outflow') {
          objBody = {
            ...objBody,
            accountReceivable: {
              ...creditForm,
              startDate: dateToDB(creditForm?.startDate),
              finalDate: dateToDB(creditForm?.finalDate),
            },
          }
        } else {
          objBody = {
            ...objBody,
            accountPayable: {
              ...creditForm,
              startDate: dateToDB(creditForm?.startDate),
              finalDate: dateToDB(creditForm?.finalDate),
            },
          }
        }
      }

      delete objBody.name
      delete objBody.search
      // delete objBody.custom

      onSubmit(objBody)
    }
  }

  const searchDefaultValue = () => {
    if (type === 'INCOME' || type == 'BANK') {
      return searchOptions[0]
    }
    if (type === 'OUTFLOW') {
      return searchOptions[1]
    }


  }

  const renderInputNumber = () => {
    let currency = accounts.find(
      (account) => account.id === selectedAccount?.value
    )?.idCurrency

    if (currency === '1') {
      return <CurrencyInput label="Monto" addDecimals={true} mask={`$. num`} />
    }

    if (currency === '2') {
      return <CurrencyInput label="Monto" addDecimals={true} mask={`Bs. num`} />
    }

    if (currency === '3') {
      return <CurrencyInput label="Monto" addDecimals={true} mask={`€. num`} />
    }

    if (currency === '4') {
      return (
        <CurrencyInput label="Monto" addDecimals={true} mask={`COP. num`} />
      )
    }
  }

  const optionsToRender = () => {
    if (type === 'BANK') {
      if (selectedMovementType === 'income') return incomeOption
      return outFlowOption
    }
    return typeOptions
  }

  const valueType = useMemo(() => {
    console.log("selected type", selectedType)
    return incomeOption?.find((income) => income?.value === selectedType) || outFlowOption.find((outflow) => outflow?.value === selectedType)
  } , [movementTypeOption, selectedType])

  const optionsDefaultValue = () : any => {
      if (type === 'BANK') {
        if (selectedMovementType === 'income') return incomeOption[0]
        return outFlowOption[0]
      }
      return typeOptions[0]
  }

  return (
    <Form form={form} onSubmit={submitValues} classes="gap-x-4">
      <h2 className="col-span-12 mb-2 text-primary-900 font-bold">
        {type === 'OUTFLOW'
          ? 'Añadir salida'
          : type === 'INCOME'
          ? 'Añadir entrada'
          : 'Añadir movimiento'}
      </h2>

      {(selectedSearch === 'client' || selectedSearch === 'provider') && (
        <FormItem
          name="name"
          classes="row-start-2 col-span-6"
          rules={{ required: 'Es necesario un nombre' }}
        >
          {/* <InputText label="Emisor" /> */}
          <RawAutoComplete
            label={type === 'BANK' ? 'Emisor/Receptor' : type === 'OUTFLOW' ? 'Receptor' : 'Emisor'}
            url={`thirdparty/${selectedSearch}/simple-search`}
            bodyGet={selectedSearch === 'client' ? 'clients' : 'providers'}
            queryParam={'param'}
            selectedValue={undefined}
            setSelectedValue={(value) => {
              console.log('value..', value)
              setselectedName(value)
            }}
          />
        </FormItem>
      )}

      {selectedSearch === 'other' && (
        <FormItem
          name="name"
          classes="row-start-2 col-span-6"
          rules={{ required: 'Es necesario un nombre' }}
        >
          {/* <InputText label="Emisor" /> */}
          <InputText label="Emisor" isUpperValue={false} />
        </FormItem>
      )}

      <FormItem
        name="search"
        classes="col-span-6"
        rules={{ required: 'Es necesario un nombre' }}
        defaultValue={searchDefaultValue()}
      >
        {/* <InputText label="Cuenta" /> */}
        {/* <InputText label="Tipo" /> */}
        <Select
          options={searchOptions}
          // value={selectedAccount}
          label="Buscar por:"
          onChange={(values) => {
            // console.log("val", values)
            if (values) {
              setSelectedSearch(values.value)
            }
          }}
        />
      </FormItem>

      {type !== 'BANK' && (
        <FormItem
          name="account.id"
          classes="row-start-3 col-span-6"
          rules={{ required: 'Es necesario un nombre' }}
        >
          {/* <InputText label="Cuenta" /> */}
          {/* <InputText label="Tipo" /> */}
          <Select
            disabled={bankOptions.length > 0}
            options={accounts?.map((v) => ({
              text: v?.description,
              value: v?.id,
            }))}
            value={selectedAccount}
            label="Cuenta"
            onChange={(values) => {
              if (values) {
                form.setValue(
                  'amount',
                  `${getDenomination(
                    accounts.find((account) => account.id === values?.value)
                      ?.idCurrency
                  )}. 0,00`
                )
                setSelectedAccount(values)
              }
            }}
          />
        </FormItem>
      )}

      {type === 'BANK' && (
        <FormItem
          name="movementType"
          classes="col-span-6 row-start-3"
          defaultValue={movementTypeOption[0]}
        >
          <Select
            options={movementTypeOption}
            // value={selectedAccount}
            label="Tipo de movimiento"
            onChange={(values) => {
              if (values) {
                if (values.value === 'income') {
                  setSelectedType(incomeOption[0].value)
                } else {
                  setSelectedType(outFlowOption[0].value)
                }
                setSelectedMovementType(values.value)
              }
            }}
          />
        </FormItem>
      )}

      <FormItem
        name="type"
        classes="row-start-3 col-span-6"
        rules={{ required: 'Es necesario un nombre' }}
        defaultValue={optionsDefaultValue()}
      >
        {/* <InputText label="Tipo" /> */}
        <Select
          defaultValue={optionsDefaultValue()}
          value={
            valueType
          }
          options={optionsToRender()}
          label="Tipo"
          onChange={(values) => {
            if (values) {
              setSelectedType(values?.value)
            }
          }}
        />
      </FormItem>

      {selectedType === 'CUSTOM' && (
        <>
        { type === 'BANK' && (
        <FormItem
          name="custom"
          classes="row-start-4 col-start-7 col-span-6 lg:col-span-12"
        >
          <RawAutoComplete
            label="Cuenta contable"
            url={selectedMovementType === 'income' ? 'accounting/simple-search' : [`accounting/simple-search`, `accounting/simple-search`]}
            bodyGet={'accounts'}
            queryParam={'search'}
            selectedValue={undefined}
            outsideParams={selectedMovementType === 'income' ? [`element=REVENUE`] : [`element=EXPENSE`, `element=COST`]}
            setSelectedValue={(value) => {
              console.log('value...', value)
              setSelectedCustom(value?.id)
              // console.log('value..', value)
              // setselectedName(value)
            }}
          />
        </FormItem>
        ) }

        { type === 'OUTFLOW' && (
        <FormItem
          name="custom"
          classes="row-start-4 col-start-7 col-span-6 lg:col-span-12"
        >
          <RawAutoComplete
            label="Cuenta contable"
            url={[`accounting/simple-search`, `accounting/simple-search`]}
            bodyGet={'accounts'}
            queryParam={'search'}
            selectedValue={undefined}
            outsideParams={[`element=EXPENSE`, `element=COST`]}
            setSelectedValue={(value) => {
              console.log('value...', value)
              setSelectedCustom(value?.id)
              // console.log('value..', value)
              // setselectedName(value)
            }}
          />
        </FormItem>
        ) }

      { type === 'INCOME' && (
        <FormItem
          name="custom"
          classes="row-start-4 col-start-7 col-span-6 lg:col-span-12"
        >
          <RawAutoComplete
            label="Cuenta contable"
            url={`accounting/simple-search`}
            bodyGet={'accounts'}
            queryParam={'search'}
            selectedValue={undefined}
            outsideParams={[`element=REVENUE`]}
            setSelectedValue={(value) => {
              console.log('value...', value)
              setSelectedCustom(value?.id)
              // console.log('value..', value)
              // setselectedName(value)
            }}
          />
        </FormItem>
        ) }

        

        </>
      )}

      {(selectedType === 'LOAN' || selectedType === 'BANK_LOAN') && (
        <div className="col-span-6">
          <label className="font-medium text-primary-900 text-xs dark:text-white">
            Cantidad de pagos
          </label>
          <input
            type="number"
            className="dark:bg-gray-800 dark:text-white mt-1 mb-2"
            name="account"
            value={creditForm?.installmentQuantity}
            onChange={(e) => {
              let [day, month, year] = (
                creditForm?.startDate ||
                `${today.day}/${today.month}/${today.year}`
              )?.split('/')
              let days =
                (+e.target.value || 0) * (+creditForm?.installmentRange || 0)
              let finalDate = DateTime.local(+year, +month, +day).plus({
                days,
              }).setLocale('es')

              setCreditForm((prevState) => ({
                ...prevState,
                installmentQuantity: e.target.value,
                finalDate: finalDate.setLocale('es').toLocaleString({
                  day: '2-digit',
                  month: '2-digit',
                  year: 'numeric',
                }),
              }))
              // setCreditForm((prevState) => ({
              //   ...prevState,
              //   installmentQuantity: e.target.value,
              //   finalDate: finalDate.toLocaleString(),
              // }))
            }}
            autoComplete="off"
          />
        </div>
      )}

      {(selectedType === 'LOAN' || selectedType === 'BANK_LOAN') && (
        <div className="col-span-6 mt-3">
          <Datepicker
            label="Fecha inicial de pago"
            onChangeDate={(date) => {
              let [day, month, year] = (
                date || `${today.day}/${today.month}/${today.year}`
              )?.split('/')
              let days =
                (+creditForm?.installmentQuantity || 0) *
                (+creditForm?.installmentRange || 0)
              let finalDate = DateTime.local(+year, +month, +day).plus({
                days,
              }).setLocale('es')

              setCreditForm((prevState) => ({
                ...prevState,
                startDate: date,
                finalDate: finalDate.setLocale('es').toLocaleString({
                  day: '2-digit',
                  month: '2-digit',
                  year: 'numeric',
                }),
              }))
            }}
          />
        </div>
      )}

      {(selectedType === 'LOAN' || selectedType === 'BANK_LOAN') && (
        <div className="col-span-6">
          <label className="font-medium text-primary-900 text-xs dark:text-white">
            Plazo entre pagos (en días)
          </label>
          <input
            type="number"
            className="dark:bg-gray-800 dark:text-white mt-1 mb-2"
            name="account"
            value={creditForm?.installmentRange}
            onChange={(e) => {
              let [day, month, year] = (
                creditForm?.startDate ||
                `${today.day}/${today.month}/${today.year}`
              )?.split('/')
              let days =
                (+e.target.value || 0) * (+creditForm?.installmentQuantity || 0)
              let finalDate = DateTime.local(+year, +month, +day).plus({
                days: days,
              }).setLocale('es')

              setCreditForm((prevState) => ({
                ...prevState,
                installmentRange: e.target.value,
                finalDate: finalDate.setLocale('es').toLocaleString({
                  day: '2-digit',
                  month: '2-digit',
                  year: 'numeric',
                }),
              }))
            }}
            autoComplete="off"
          />
        </div>
      )}

      {(selectedType === 'LOAN' || selectedType === 'BANK_LOAN') && (
        <div className="col-span-6 flex flex-row justify-around items-center">
          <h3 className="lg:mr-3">Fecha final:</h3>
          <h3>{creditForm?.finalDate}</h3>
        </div>
      )}

      {(selectedType === 'LOAN' || selectedType === 'BANK_LOAN') && (
        <div className="col-span-12 mt-6">
          <div className="flex flex-row mb-3">
            <label className="font-medium text-primary-900 text-xs dark:text-white">
              Indexar deuda
            </label>
            <Tooltip
              xOffset={20}
              title="La deuda se guardará referencialmente en USD y se reajustará automáticamente a la tasa de cambio"
            >
              <GrCircleInformation
                size={12}
                className="ml-3"
                style={{ marginTop: -5 }}
              />
            </Tooltip>
          </div>
          <Switch
            value={creditForm?.currency?.id === '1'}
            forForm={true}
            onChange={(v) =>
              setCreditForm((prevState) => ({
                ...prevState,
                currency: {
                  id: v ? '1' : '2',
                },
              }))
            }
          />
        </div>
      )}

      <FormItem
        name="amount"
        classes={`${
          selectedType === 'CUSTOM' && 'xl:row-start-5'
        } xl:col-span-3 lg:col-span-6`}
        rules={{ required: 'Es necesario un nombre' }}
      >
        {/* <InputText label="Monto" /> */}
        {/* <InputNumber label="Monto" addDecimals={true} /> */}
        <CurrencyInput
          label="Monto"
          addDecimals={true}
          mask={`${
            type === 'BANK'
              ? getDenomination(idCurrency!)
              : getDenomination(
                  accounts.find(
                    (account) => account.id === selectedAccount?.value
                  )?.idCurrency
                )
          } ${idCurrency === '2' ? '.' : ''} num`}
        />
        {/* {renderInputNumber()} */}
      </FormItem>

      <FormItem
        name="date"
        classes={`${
          selectedType === 'CUSTOM' && 'xl:row-start-5'
        } xl:col-span-3 mt-1 lg:col-span-6`}
        rules={{ required: 'Es necesario un nombre' }}
      >
        {/* <InputText label="Fecha" /> */}
        <Datepicker label="Fecha" />
      </FormItem>

      <FormItem
        name="reference"
        classes={`${
          selectedType === 'CUSTOM' && 'xl:row-start-5'
        } xl:col-span-6 lg:col-span-12`}
        rules={{ required: 'Es necesario un nombre' }}
      >
        <InputText label="Referencia" isUpperValue={false} />
      </FormItem>

      <FormItem
        name="description"
        classes={`${selectedType === 'CUSTOM' && 'row-start-6'} xl col-span-12`}
        rules={{ required: 'Es necesario un nombre' }}
      >
        <InputText label="Descripción" isUpperValue={false} />
      </FormItem>

      <div className="h-px dark:bg-primaryGray-600 bg-primaryGray-700 col-span-12 mt-5"></div>

      <div className="flex flex-row col-span-12 mt-5">
        {onClose && (
          <Button
            type="outline"
            classes="w-1/2 mr-4"
            onClick={() => onClose()}
            htmlType="button"
          >
            Cancelar
          </Button>
        )}
        <Button type="primary" classes="w-1/2 mr-4" htmlType="submit">
          Añadir
        </Button>
      </div>
    </Form>
  )
}

interface IInvoiceForm {
  onClose: () => void
  onSubmit: (values: any) => void
  type: 'INCOME' | 'OUTFLOW' | 'BANK'
  bankOptions?: any[]
  idCurrency?: string | undefined
}

export default IncomeForm
